import { t } from 'i18next'
import { Action, any, async, AsyncState, HttpResult, loadingAsyncState, mkWidget, mk_pair, mk_widget, onlyIf, route, Widget } from "widgets-for-react";
import { Set } from "immutable";
import { CustomPage, CustomPagesState, PublicSiteCustomRoutes, Vacancy } from "../../types.mod";
import { getTranslatedCareersSlugTitle, PublicSiteState } from "../../../../../public_site.main.mod";
import { CustomRouteParams } from "../../../../cms/router/type.gen";
import { getFormState } from "../../../../form/api";
import React = require("react");
import { Loader } from "../overviewPage/overview_page";
import { Form } from "../../../../form";
import { FormState } from "../../../../form/types";
import { TextBlock } from "../../../../cms/blocks/widgets/textBlock.gen";
import { textBlockClasses } from "../../../blocks/style.mod";
import { getLangFromUrl } from "../../../utils/history.mod";
import { vacancyApplicationFormPageHeader, vacancyDetailPageHeader } from "../../../templates/custom_page_header";
import { recruitmentProcessBlock } from '../../../blocks/custom_blocks/widgets/recruitmentProcessBlock';
import { vacancyFooterButtonFormDatalayer, vacancyFormFormDatalayer } from '../../../../datalayer';
import { getDrupalLanguage } from '../../../application.mod';
import { notfound_page } from '../../../templates/error_page.mod';

const createWithId = (id: string) => {
  let element = document.createElement("div")
  element.id = id
  return element
}

export const closeJobPostingDiv = () => {
  let jp_api = document.getElementById('job_posting')
  if (jp_api) jp_api.replaceWith(createWithId("job_posting"))
}

export const getVacancy = (vacancyId: string): Promise<HttpResult<Vacancy>> =>
  fetch(`/api/v1/CustomFormLogic/GetVacancy/${getDrupalLanguage(getLangFromUrl())}/${vacancyId}`)
    .then(res => res.json())
    .then(json => json as { vacancy: Vacancy, job_posting_data: string })
    .then(value => {
      var job_posting_script = document.createElement('div');
      job_posting_script.innerHTML = value.job_posting_data
      job_posting_script.id = "job_posting"
      let job_posting_data = document.getElementById('job_posting')
      if (job_posting_data) job_posting_data.replaceWith(job_posting_script)

      return {
        kind: "result",
        status: 200,
        value: value.vacancy
      }
    })

export const vacancyDetailPathPattern = `/:lang?/:careers/vacancies/id/:vacancyId/:title/:tag`

export const vacancy_detail: CustomPage<CustomPagesState["vacancyItem"]> = {
  widget: _r => mkWidget({
    run: (setState: (_: Action<CustomPagesState["vacancyItem"]>) => void) => {
      let r = mk_pair(_r.fst, _r.snd)
      let s = r.snd;
      let vacancyId = r.fst.kind == "vacancyItem" ? r.fst.vacancyId : ""
      if (s.get_vacancy.kind == "unloaded") setState(s => ({ ...s, get_vacancy: loadingAsyncState(() => getVacancy(vacancyId)) }))

      return vacancyDetailWidget(s, _ => { }).run(setState)
    }
  }),
  route: route<
    {
      vacancyId: string
    },
    CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>
  >(vacancyDetailPathPattern, (s) => {
    return {
      kind: 'vacancyItem',
      vacancyId: s.vacancyId
    }
  }),
  getState: (s: PublicSiteState) => s.vacancyItem,
  setState: (s: PublicSiteState, ss: CustomPagesState["vacancyItem"]) => {
    return { ...s, vacancyItem: ss }
  },
  updateStateBasesOnRoute: (s, r) => {
    if (r.kind != "vacancyItem") return s


    return ({
      ...s,
      vacancyItem: {
        ...s.vacancyItem,
        // cookiestate: s.cookiestate,
        get_vacancy: loadingAsyncState(() => getVacancy(r.vacancyId)),
        current_view: "vacancy-detail",
        form: {
          ...getFormState([], `VacancyApplication2`, r.vacancyId),
          custom_context: { VacancyId: r.vacancyId, Kind: "", Language: getDrupalLanguage(getLangFromUrl()) }
        }
      }
    })
  }
}

const vacancyDetailWidget = (
  s: CustomPagesState["vacancyItem"],
  set_public_state: (output: Action<PublicSiteState>) => void
): Widget<Action<CustomPagesState["vacancyItem"]>> => {
  let vacancy = s.get_vacancy && s.get_vacancy.kind == "loaded" ? s.get_vacancy.value : undefined

  let lang =getLangFromUrl()

  const currentLang = getLangFromUrl()
  let careersSlugTranslationData = getTranslatedCareersSlugTitle()
  let careersSlug = careersSlugTranslationData.slug[currentLang]
  let careersTitle = careersSlugTranslationData.title[currentLang]
  
  return mk_widget({

    run: set_state => {
      return <>
        <div className='main main--vacancy'>
          <div className='main__inner'>
            <div className='page'>
              <div className='page__inner'>
                {async<Vacancy>()(s.get_vacancy).map(a =>
                  s => {
                    let s1 = { ...s, get_vacancy: a(s.get_vacancy) }
                    let form = s1.form
                    let vacancy: AsyncState<Vacancy> = s1.get_vacancy
                    if (vacancy.kind == "loaded") {
                      form.custom_context.Kind = vacancy.value.Kind
                    }
                    return s1
                  }).run(a => {
                    set_state(a)
                  })}

                <div className='page__content'>
                  {s.current_view == "apply-form" ?
                    vacancyApplicationFormPageHeader(vacancy.Name).run(_ => ({ _ }))
                    : s.get_vacancy.kind == "loaded" ?
                      [ vacancy.Id == null ? 
                        [ 
                          notfound_page(null).run(() => { })
                        ]
                        : 
                        [
                          vacancyDetailPageHeader(currentLang, careersSlug, careersTitle, vacancy, set_state).run(_ => { }),
                          <div className="block block--form">
                            <div className="block__inner container container--m grid--block">
                              <div className="block__content">
                                <a className="link link--back" onClick={() => location.href = `/${getLangFromUrl()}/${getTranslatedCareersSlugTitle().slug[lang]}/vacancies`}>
                                  <span>{t(`Vacancy:all_vacancies`)}</span>
                                  <svg className="link__icon" height="14" width="18">
                                    <use xlinkHref="#icon--arrow" />
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>,
                          vacancyWidget(s.get_vacancy.value, set_public_state, set_state).run(_ => { })
                        ]
                      ]
                    : Loader()
                  }

                  {onlyIf(s.get_vacancy.kind == "loaded",
                    mk_widget({
                      run: set_state => {
                        if (s.current_view == 'apply-form') {
                          vacancyFormFormDatalayer("start_application")
                        }
                        return (
                          <>
                            <section className="block block--form">
                              <div className="block__inner container container--m grid--block">
                                <div className="block__content">

                                  {s.current_view == "apply-form" ?
                                    <>
                                      <a className="link link--back" onClick={_ => set_state(s => ({ ...s, current_view: "vacancy-detail" }))}>
                                        <span>{t("Vacancy:return_to_vacancy")}</span>
                                        <svg className="link__icon" height="14" width="18">
                                          <use xlinkHref="#icon--arrow" />
                                        </svg>
                                      </a>
                                      <h2 className="block__title">{t("Vacancy:application_for")} {vacancy.Name}</h2>
                                    </>
                                    : null}
                                  {s.current_view == "apply-form" ? Form(s.form)
                                    .map((a) => (s) => {
                                      let form1: FormState = a(s.form)
                                      if (form1.form_submission_logic.kind == "loaded") {
                                        vacancyFormFormDatalayer("submit_application")
                                      }
                                      let s1 = { ...s, form: form1 }
                                      return s1
                                    })
                                    .run(set_state) : null}

                                </div>
                              </div>
                            </section>
                          </>
                        )
                      }
                    })).run(set_state)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    }
  })
}

const vacancyWidget = (
  vacancy: Vacancy,
  set_public_state: (output: Action<PublicSiteState>) => void,
  set_state: (output: Action<{ get_vacancy: AsyncState<Vacancy>; form: FormState; current_view: "vacancy-detail" | "apply-form"; }>) => void
): Widget<Vacancy> => {

  const applyButtonOnClick = _ => {
    set_state(s => ({ ...s, current_view: "apply-form" }))
    vacancyFooterButtonFormDatalayer(t("Vacancy:apply_now"))
  }
  const widgets = [
    titledBodyWidget("", vacancy.Description),
    // titledBodyWidget(i18next.t('Vacancy.JobRequirements'), vacancy.ToVacancy.CRVacancy.Requirements)
    recruitmentProcessBlock(vacancy.Department, vacancy.Language),
    (_) => mk_widget({
      run: _ => {
        {
          return (
            <section className="block block--apply apply">
              <div className="block__inner container container--m grid--block">
                <div className="block__content">
                  <h2 className="apply__title title--l">{t("Vacancy:apply_now")}</h2>
                  <div className="apply__message">
                    <p>
                      {t("Vacancy:apply_now_message")}
                    </p>
                  </div>
                  <div className="apply__buttons">
                    <button className="button button--primary"
                      onClick={applyButtonOnClick}>
                      {t("Vacancy:apply_now")}
                    </button>
                    {/* <a
                      className="button button--secondary"
                      href={`mailto:?subject=&body= Remember this vacancy.%0D%0A%0D%0A ${vacancy.Name} - link: ${window.location.href}`} >
                      {t("Vacancy:contact_recruiter")}
                    </a> */}
                  </div>
                </div>
              </div>
            </section>
          )
        }
      }
    })

  ]

  return any<Vacancy>()(
    widgets.map((w, i) => w(i))
  )
}

const titledBodyWidget = (title: string, text: string) => (index: number): Widget<any> => {
  let text1 = (text || "")
    // .replace(/style="font-family: arial , helvetica , sans-serif;font-size: 10.0pt;"/g, '')
    // .replace(/style="font-family: arial, helvetica, sans-serif; font-size: 10pt;"/g, '')
    // .replace(/style="display:none"/g, '')
    // .replace(/style="font-family: arial , helvetica , sans-serif; font-size: 10.0pt;"/g, '')
    // .replace(/style="font-family: arial , helvetica , sans-serif; font-size: 10.0pt";/g, '')
    // .replace(/style="style="font-size:8.5pt;font-family:&quot;Arial&quot;,sans-serif;color:black;background:white";/g, '')
    // .replace(/font-size: 8.5pt; font-family: Arial, sans-serif; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;/g, "")
    .replace(/\s?\w*=".*?"\s?/g, "")
    // .replace(/\<span\>/g, "<p>")
    // .replace(/\<span \>/g, "<p>")
    // .replace(/\<\/span\>/g, "</p>")
    .replace(/arial,helvetica,sans-serif/g, "")
    .replace(/size="2"/g, "")
    .replace(/font-family: ; font-size: 10pt;/g, "")
    .replace(/font-family:/g, "font-famil:")
    .replace(/font-size:/g, "font-siz:")
    .replace(/background-image:/g, "background-imag:")
    .replace(/<br data-mce-bogus="1">/g, "")
    .replace(/&nbsp;/g, " ")
  // can be used for testing:
  // console.log(text1)

  return TextBlock({
    title: title,
    text: text1,
    index: index,
    link_type: false
  }, { style: textBlockClasses })(null)
}